import { Component, Input, OnDestroy } from '@angular/core';
import { monitoring } from '@caslink/common-client';
import { controls } from '@caslink/device-client/ng-app/shared/models/device-routes.enum';
import { DashboardDeviceSummary } from '@caslink/device-client/ng-app/shared/models/dashboard-device-summary.interface';
import { DashboardAreaSummary } from '@caslink/device-client/ng-app/shared/models/dashboard-area-summary.interface';
import { DashboardCacheService } from './dashboard-cache.service';

@Component({
    selector: 'dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnDestroy {
    static $name: string = 'dashboard';

    get monitoringState() {
        return monitoring.sensors;
    }

    get controlsState() {
        return controls.controlsDetails;
    }

    get dashboardAreas() {
        return this.dashboard?.areas;
    }

    @Input() dashboard: CASLink.Device.Ui.ViewModel.Dashboard.DashboardViewModel;
    @Input() locationId: number;

    ngOnDestroy(): void {
        this.dashboard.areas
            .forEach(area => area.devices
                .forEach((device: DashboardDeviceSummary) => {
                    if (device.model && device.model.controls) {
                        device.model.controls.forEach(control => control.stopLiveModelUpdates());
                    }
            }));
    }

    ngOnInit() {
        this.dashboardCacheService.setCachedDashboard({locationId: this.dashboard.locationId, areas: this.dashboard.areas});
    }

    constructor(
        private dashboardCacheService: DashboardCacheService,
    ) {
    }

    getTag(area: DashboardAreaSummary): string {
        if (!area.areaTag) {
            return 'Without Area';
        }
        return area.areaTag;
    }

    getAreaIcon(area: DashboardAreaSummary): string {
        if (!area.areaIcon || area.areaIcon === '') {
            return 'monitoringDefault';
        }
        return area.areaIcon;
    }

    getExpandIcon(area: DashboardAreaSummary): string {
        return area.$hidden ? 'expand_more' : 'expand_less';
    }

    toggleArea(area: DashboardAreaSummary) {
        area.$hidden = !area.$hidden;
    }

    getLinkParams(area: DashboardAreaSummary) {
        return {
            areaId: area.areaId,
            locationId: this.dashboard.locationId,
            hardwareItemId: null,
        };
    }

}
